export interface Partner {
  name: string;
  logo: string;
  logoAlt: string;
  description: string;
  url?: string;
  category: 'transportation' | 'food' | 'culture' | 'healthcare' | 'technology';
}

export const partners: Partner[] = [
  {
    name: "Uber",
    logo: "/logos/partners/uber.png",
    logoAlt: "Uber",
    description: "Reliable transportation services for medical appointments and daily needs",
    url: "https://uber.com",
    category: "transportation"
  },
  {
    name: "Lyft",
    logo: "/logos/partners/lyft.png", 
    logoAlt: "Lyft",
    description: "Safe and convenient rides for seniors and their families",
    url: "https://lyft.com",
    category: "transportation"
  },
  {
    name: "Uber Eats",
    logo: "/logos/partners/uber-eats.png",
    logoAlt: "Uber Eats", 
    description: "Food delivery from favorite local restaurants",
    url: "https://ubereats.com",
    category: "food"
  },
  {
    name: "DoorDash",
    logo: "/logos/partners/doordash.png",
    logoAlt: "DoorDash",
    description: "Convenient meal delivery and grocery services",
    url: "https://doordash.com", 
    category: "food"
  },
  {
    name: "Grubhub",
    logo: "/logos/partners/grubhub.png",
    logoAlt: "Grubhub",
    description: "Easy online food ordering and delivery",
    url: "https://grubhub.com",
    category: "food"
  },
  {
    name: "Art Institute of Chicago",
    logo: "/logos/partners/art-institute-chicago.png",
    logoAlt: "Art Institute of Chicago",
    description: "Virtual museum tours and cultural enrichment programs",
    url: "https://artic.edu",
    category: "culture"
  },
  {
    name: "Harvard Art Museums",
    logo: "/logos/partners/harvard-art-museum.png", 
    logoAlt: "Harvard Art Museums",
    description: "Online art collections and educational content",
    url: "https://harvardartmuseums.org",
    category: "culture"
  }
];

export const partnerCategories = {
  transportation: "Transportation Services",
  food: "Food & Delivery Services", 
  culture: "Cultural Institutions",
  healthcare: "Healthcare Partners",
  technology: "Technology Partners"
} as const;